<template>
  <div id="AppLogin">
    <div style="height: 100px;" />
    <div class="modal-card" style="width: 600px;">
      <header class="modal-card-head" style="border: 1px solid #dbdbdb; padding-top: 0px; padding-bottom: 0px;">
        <img src="../assets/logo.png" width="90px;" height="auto;" />
        <p
          class="modal-card-title has-text-centered"
          style="color: whitesmoke"
        >スケジュール管理システム Philips SMS</p>
      </header>
      <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
        <b-field
          label="メールアドレス"
          :type="{'is-danger': errors.has('userId')}"
          :message="errors.first('userId')"
        >
          <b-input
            name="userId"
            data-vv-as="メールアドレス"
            type="text"
            v-model="userId"
            v-validate="'required|email|max:256'"
            placeholder="メールアドレスを入力してください"
          ></b-input>
        </b-field>

        <b-field
          label="パスワード"
          :type="{'is-danger': errors.has('password')}"
          :message="errors.first('password')"
        >
          <b-input
            name="password"
            data-vv-as="パスワード"
            type="password"
            v-model="password"
            password-reveal
            placeholder="パスワードを入力してください"
            v-validate="'required'"
          ></b-input>
        </b-field>
        <template v-if="fromApp">
          <b-field
            label="ワンタイムパスワード"
            :type="{'is-danger': errors.has('otp')}"
            :message="errors.first('otp')"
          >
            <b-input
              name="otp"
              data-vv-as="ワンタイムパスワード"
              v-model="otp"
              type="text"
              placeholder="ワンタイムパスワードを入力してください"
              v-validate="'required|numeric'"
            ></b-input>
          </b-field>
        </template>
      </section>
      <footer class="modal-card-foot" style="border: 1px solid #dbdbdb;">
        <div>
          <b-button
            class="button is-primary is-inverted has-text-centered"
            icon-left="login"
            type="button"
            :disabled="!isActive"
            v-on:click="login"
          >ログイン</b-button>
          <b-button
            class="button is-light is-inverted has-text-centered"
            icon-left="eraser"
            :disabled="!isActive"
            v-on:click="passwordInit"
          >パスワード初期化</b-button>
        </div>
        <div
          class="is-inverted has-text-right"
          style="color:white; text-align:right;width:45%;"
        >Ver.{{version}}</div>
      </footer>
    </div>
    <div style="height: 100px;" />
  </div>
</template>

<script>
export default {
  name: "AppLogin",
  data() {
    var version = this.$store.state.version;
    var validFlag = true;
    var accessType = "ブラウザ"
    if (
      navigator.platform == "iPad" || // -iOS12
      (navigator.platform == "MacIntel" && // iPadOS
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1 &&
        navigator.standalone !== undefined) ||
      navigator.userAgent == "AppGuardian"
    ) {
      // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
      if (navigator.userAgent.endsWith("AppGuardian")) {
        // WkWebViewのためiPadアプリ
        accessType = "iPad"
      } else {
        alert(
          "使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。"
        );
        validFlag = false;
      }
    }
    if (validFlag) {
      sessionStorage.removeItem("guardianToken");
      var guardianToken = this.$route.query.token;
      if (guardianToken) {
        this.$store
          .dispatch("loginWithToken", {
            token: guardianToken
          })
          .then(() => {
            sessionStorage.setItem("guardianToken", guardianToken);
            this.$store.dispatch("getBranchMaster", {});
            this.$store.dispatch("getOfficeMaster", {});
            this.$store.dispatch("getPositionMaster", {});
            this.$store.dispatch("getInspectionHardwareMaster", {});
            this.$router.push({ path: "/main/Welcome" });
          })
          .catch(error => sessionStorage.removeItem("guardianToken"));
      }
    }
    return {
      userId: "",
      password: "",
      otp: "",
      isActive: true,
      accessType,
      version
    };
  },
  methods: {
    login: function(event) {
      console.log("login called.");
      const isSSOLogin = this.$store.state.isSSOLogin;
      
      if (isSSOLogin){
        new Promise(resolve => {
          this.$store._vm.$dialog.confirm({
            title: '　',
            message: "<p>　システムのURLが変更になりましたので　</p>" 
                 + "<p>　下のSSO認証ボタンよりログイン画面に　</p>"
                 + "<p>　移動しログインをしてください。　</p>"
                 + "<p>　<span class='sso-message-background-color'>新URLのブックマークをお願いします。</div></p>",
            canCancel: false,
            confirmText: 'SSO認証',
            onConfirm: () => {
              window.location.href = this.$store.state.ssoLogin;
            },
          });
        });
        return
      }
      
      this.isActive = false;
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          this.accessType = "iPad"
        } else {
          alert(
            "使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。"
          );
          return;
        }
      } else {
        // MacOS
        this.accessType = "ブラウザ"
      }

      var guardianToken = sessionStorage.getItem("guardianToken");
      if (sessionStorage.getItem("userInfo")) {
        this.$store.dispatch("logout", { token: guardianToken });
      }
      // TODO パスワードハッシュ化
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch("login", {
              mail: this.userId,
              password: this.password,
              otptoken: this.otp,
              accessType:this.accessType,
              isSSOLogin:isSSOLogin
            })
            .then(result => {
              console.log(result);
              if (result != 0) {
                throw new Error();
              }
              this.isActive = true;
              this.$store.dispatch("getBranchMaster", {});
              this.$store.dispatch("getOfficeMaster", {});
              this.$store.dispatch("getPositionMaster", {});
              this.$store.dispatch("getInspectionHardwareMaster", {});
              var isPasswordModified = JSON.parse(
                sessionStorage.getItem("userInfo")
              ).isPasswordModified;
              if (isPasswordModified) {
                this.$router.push({ path: "/main/Welcome" });
              } else {
                this.$router.push({
                  name: "AppPasswordForceChange",
                  params: { currentpassword: this.password }
                });
              }
            })
            .catch(error => {
              this.isActive = true;
            });
        } else {
          this.isActive = true;
        }
      });
    },
    passwordInit: function(event) {
      const isSSOLogin = this.$store.state.isSSOLogin;
      
      if (isSSOLogin){
        new Promise(resolve => {
          this.$store._vm.$dialog.confirm({
            title: '　',
            message: "<p>　システムのURLが変更になりましたので　</p>" 
                 + "<p>　下のSSO認証ボタンよりログイン画面に　</p>"
                 + "<p>　移動しログインをしてください。　</p>"
                 + "<p>　<span class='sso-message-background-color'>新URLのブックマークをお願いします。</div></p>",
            canCancel: false,
            confirmText: 'SSO認証',
            onConfirm: () => {
              window.location.href = this.$store.state.ssoLogin;
            },
          });
        });
        return
      }
      this.$router.push("/pwdInit");
    }
  },
  computed: {
    fromApp() {
      var ret = false;
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        ret = true;
      }
      return ret;
    }
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

<style>
.sso-message-background-color {
  background-color: #FFE5B4;
}
</style>


// WEBPACK FOOTER //
// src/components/AppLogin.vue